import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LeftSideNavaBarAdmin from './LeftSideNavaBarAdmin';

const Subcategory = () => {
    const [categories, setCategories] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState('');
    const [subcategoryName, setSubcategoryName] = useState('');
    const [subcategoryCode, setSubcategoryCode] = useState('');
    const [message, setMessage] = useState('');

    // Fetch all categories for dropdown
    const fetchCategories = async () => {
        try {
            const response = await axios.get('/api/categories');
            setCategories(response.data);
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    // Save subcategory
    const handleSaveSubcategory = async (e) => {
        e.preventDefault();

        if (!selectedCategoryId) {
            setMessage('Please select a category.');
            return;
        }

        try {
            await axios.post('/api/add-subcategory', {
                categoryId: selectedCategoryId,
                subcategoryName,
                subcategoryCode,
            });

            setMessage('Subcategory saved successfully!');
            setSubcategoryName('');
            setSubcategoryCode('');
        } catch (error) {
            setMessage('Failed to save subcategory.');
            console.error(error);
        }
    };

    return (
        <div>
            <div className="content-wrapper">
                <div className="breadcrumb-wrap bg-f br-1">
                    <div className="container">
                        <div className="breadcrumb-title">
                            <h2>Admin</h2>
                            <ul className="breadcrumb-menu list-style">
                                <li><a href="/">Home</a></li>
                                <li>Subcategory</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="blog-wrap pt-40">
                    <div className="container">
                        <div className="row gx-5">
                            <LeftSideNavaBarAdmin />

                            <div className="col-xl-8 col-lg-12">
                                <div className="admin-subcategory-form">
                                    <h2>Subcategory Form</h2>

                                    <div className="subcategory-category-select">
                                        <h3>Select Parent Category</h3>
                                        <select
                                            value={selectedCategoryId}
                                            onChange={(e) => setSelectedCategoryId(e.target.value)}
                                            className="category-dropdown"
                                        >
                                            <option value="">Select a Category</option>
                                            {categories.map((category) => (
                                                <option key={category.categoryId} value={category.categoryId}>
                                                    {category.categoryName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <p><strong>Subcategory Name:</strong></p>
                                    <input
                                        type="text"
                                        value={subcategoryName}
                                        onChange={(e) => setSubcategoryName(e.target.value)}
                                        placeholder="Enter subcategory name"
                                        className="subcategory-input"
                                    />

                                    <p><strong>Subcategory Code:</strong></p>
                                    <input
                                        type="text"
                                        value={subcategoryCode}
                                        onChange={(e) => setSubcategoryCode(e.target.value)}
                                        placeholder="Enter subcategory code"
                                        className="subcategory-input"
                                    />

                                    <button onClick={handleSaveSubcategory} className="save-button">
                                        Save Subcategory
                                    </button>

                                    {message && <p className="message">{message}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .admin-subcategory-form {
                    font-family: Arial, sans-serif;
                    max-width: 600px;
                    margin: 20px auto;
                    padding: 20px;
                    background-color: #f9f9f9;
                    border-radius: 8px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }

                h2 {
                    text-align: center;
                    margin-bottom: 20px;
                    color: #333;
                }

                .subcategory-category-select {
                    margin-bottom: 20px;
                }

                .category-dropdown {
                    width: 100%;
                    padding: 10px;
                    margin-bottom: 20px;
                    font-size: 16px;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    outline: none;
                }

                .subcategory-input {
                    width: 100%;
                    padding: 10px;
                    font-size: 16px;
                    border: 1px solid #ccc;
                    border-radius: 4px;
                    margin-bottom: 20px;
                    outline: none;
                    transition: border-color 0.3s;
                }

                .subcategory-input:focus {
                    border-color: #007bff;
                }

                .save-button {
                    width: 100%;
                    padding: 12px;
                    font-size: 16px;
                    background-color: #28a745;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    cursor: pointer;
                    transition: background-color 0.3s;
                }

                .save-button:hover {
                    background-color: #218838;
                }

                .message {
                    text-align: center;
                    font-size: 16px;
                    color: #333;
                }
            `}</style>
        </div>
    );
};

export default Subcategory;
